import "core-js/modules/es.array.index-of";
import "core-js/modules/es.date.to-string";
import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
import { del, get, set } from '@/lib/service/storage';
import { decodeJwtPayload } from '@/lib/script/crypto';
var m = {
  namespaced: true,
  state: function state() {
    return {
      jwt: null,
      parsedJwt: null,
      hasLogin: false,
      requestLogin: false
    };
  },
  mutations: {
    /**
     * 记录jwt
     */
    setJwt: function setJwt(state, jwt) {
      state.jwt = jwt;
      state.parsedJwt = decodeJwtPayload(jwt);
      Vue.axios.defaults.headers.common.Authorization = 'Bearer ' + jwt;
      document.cookie = "t=" + jwt + ";expires=" + new Date(state.parsedJwt.exp * 1000);
      set('jwt', jwt);
    },

    /**
     * 设置是否已经登录
     *
     * @param {} hasLogin
     */
    setLogin: function setLogin(state, hasLogin) {
      state.hasLogin = hasLogin;
    },

    /**
     * 标记当前是否正在请求login
     *
     * @param {} request
     */
    setRequestLogin: function setRequestLogin(state, request) {
      state.requestLogin = request;
    }
  },
  actions: {
    /**
     * 登录
     *
     * @param {} 所有需要发送的参数
     *
     * @return {} rdata
     */
    login: function login(_a, params) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata, cookie, jwt;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              if (state.hasLogin || params && params.state && params.state.indexOf('wechat') < 0) {
                // 模拟rdata
                return [2
                /*return*/
                , {
                  status: 0
                }];
              }

              if (state.requestLogin) {
                return [2
                /*return*/
                , {
                  status: 3
                }];
              }

              commit('setRequestLogin', true);
              console.log('target login_wechat_params', params);
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/auth/login_wechat', {
                code: params.code
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;
              cookie = document.cookie;
              console.log('target 验证码cookie', cookie);

              if (response.request.cookie || cookie) {
                set('bindmobile_jwt', response.request.cookie || cookie);
              }

              console.log('target login_wechat_response_data', response);

              if (rdata.status === 0) {
                commit('setLogin', true);
                jwt = rdata.data;

                if (jwt) {
                  commit('setJwt', jwt);
                  set('jwt', jwt);
                }
              }

              commit('setRequestLogin', false);
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 发送验证码
     */
    sendLoginSms: function sendLoginSms(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var areaCode = _b.areaCode,
          phone = _b.phone;
      return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/auth/send_login_sms', {
                area_code: areaCode,
                phone: phone
              })];

            case 1:
              response = _c.sent();
              return [2
              /*return*/
              , response.data];
          }
        });
      });
    },

    /**
     * 检查验证码是否正确
     * @param areaCode
     */
    checkLoginSms: function checkLoginSms(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var areaCode = _b.areaCode,
          phone = _b.phone,
          code = _b.code,
          deviceId = _b.deviceId,
          type = _b.type;
      return __awaiter(this, void 0, void 0, function () {
        var cookie, response;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              cookie = get('bindmobile_jwt');
              console.log('target 绑定手机号', cookie);
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/auth/check_login_sms', {
                area_code: areaCode,
                phone: phone,
                code: code,
                device_id: deviceId,
                type: type
              }, {
                headers: {
                  Cookie: cookie
                }
              })];

            case 1:
              response = _c.sent();
              del('bindmobile_jwt');
              return [2
              /*return*/
              , response.data];
          }
        });
      });
    }
  }
};
export default m;